import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Box from "../../../widgets/Box/Box";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import PersonIcon from "@mui/icons-material/Person";

import tokenUtils from "../../../utils/tokenUtils";
import routes from "../../../constants/routes";

import styles from "../header.module.scss";

const ProfileMenu = ({ onViewProfile }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const navigate = useNavigate();

  const handleViewProfile = () => {
    handleClose();
    onViewProfile();
  };

  const handleLogout = () => {
    handleClose();
    tokenUtils.deleteToken();
    navigate(routes.login.root, {
      replace: true,
      state: { successMessage: "You have been logged out successfully." },
    });
  };

  const adminDetails = tokenUtils.getDecodedToken();
  const initials = adminDetails
    ? `${adminDetails.FirstName?.[0] || ""}${adminDetails.LastName?.[0] || ""}`.toUpperCase()
    : "A";

  return (
    <Box>
      <Tooltip title="Account settings">
        <IconButton onClick={handleOpen} className={styles.profileMenuBtn}>
          <Avatar className={styles.headerAvatar}>{initials}</Avatar>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={styles.profileMenuMenu}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            elevation: 3,
            className: styles.profileMenuPaper,
          },
        }}
      >
        <MenuItem
          onClick={handleViewProfile}
          className={styles.profileMenuItem}
        >
          <PersonIcon className={styles.profileMenuItemIcon} />
          View Profile
        </MenuItem>

        <Divider className={styles.profileMenuDivider} />

        <MenuItem
          onClick={handleLogout}
          className={`${styles.profileMenuItem} ${styles.profileMenuItemLogout}`}
        >
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ProfileMenu;
